import BurnoutButtonLinkNext from './BurnoutButtonLinkNext';

import { FaChevronRight } from 'react-icons/fa';

interface Props {
  colorSwap?: boolean;
  fromLabel: string;
  href: string;
  linkLabel: string;
}

export default function BurnoutBreadCrumbNext({ colorSwap, fromLabel, href, linkLabel }: Props) {
  return (
    <div className='flex w-full items-center gap-3'>
      <div className='w-fit'>
        <BurnoutButtonLinkNext colorSwap={colorSwap} href={href}>
          {linkLabel}
        </BurnoutButtonLinkNext>
      </div>
      <FaChevronRight className='h-6 w-6' />
      <p className='font-semibold'>{fromLabel}</p>
    </div>
  );
}
